import { DEFAULT_LAYOUT } from '../base';
import { type AppRouteRecordRaw } from '../types';
import { IconSettings } from "@arco-design/web-vue/es/icon";

const routes: AppRouteRecordRaw = {
  path: '/system-operation',
  redirect: '/system-operation/weight-audit',
  component: DEFAULT_LAYOUT,
  meta: {
    title: '系统操作',
    icon: IconSettings,
    // hideChildrenInMenu: true,
    order: 500,
    roles: ['admin'],
  },

  children: [
    {
      path: 'weight-audit',
      component: () => import('@/views/system-operation/weight-audit.vue'),
      meta: {
        title: '权重审核',
      },
    },
    {
      path: 'weight-key-management',
      component: () => import('@/views/system-operation/weight-key-management.vue'),
      meta: {
        title: '权重键管理',
      },
    },
    {
      path: 'add-weight-key/:id?',
      component: () => import('@/views/system-operation/components/add-weight-key.vue'),
      props: true,
      meta: {
        title: '新增权重键',
        hideInMenu: true,
      },
    },
    {
      path: 'org-power-review',
      props: true,
      component: () => import('@/views/system-operation/org-power-review.vue'),
      meta: {
        title: '组织权限审核',
        // hideInMenu: true,
      },
    },

    {
      path: 'default-org',
      props: true,
      component: () => import('@/views/system-operation/default-org.vue'),
      meta: {
        title: '组织权限管理',
        // hideInMenu: true,
      },
    },
    {
      path: 'org-evaluation-history',
      props: true,
      component: () => import('@/views/system-operation/org-evaluation-history.vue'),
      meta: {
        title: '组织历史评价',
        // hideInMenu: true,
      },
    },
    {
      path: 'upload-project',
      props: true,
      component: () => import('@/views/system-operation/upload-project.vue'),
      meta: {
        title: '导入项目/项目群',
        // hideInMenu: true,
      },
    },
  ],
};

export default routes;
